import { render, staticRenderFns } from "./KnockHeader.vue?vue&type=template&id=a31a56fa&scoped=true&"
import script from "./KnockHeader.vue?vue&type=script&lang=js&"
export * from "./KnockHeader.vue?vue&type=script&lang=js&"
import style0 from "./KnockHeader.vue?vue&type=style&index=0&id=a31a56fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31a56fa",
  null
  
)

export default component.exports